import type { AgentGraphNodeType } from '../types/agentPlatform';

export interface AgentGraphNodeModel {
  id: string;
  type: AgentGraphNodeType;
  config: Record<string, unknown>;
}

export interface AgentGraphEdgeModel {
  from: string;
  to: string;
  condition?: Record<string, unknown> | null;
}

export interface AgentGraphDefinitionModel {
  entryNodeId: string;
  nodes: AgentGraphNodeModel[];
  edges: AgentGraphEdgeModel[];
  settings: {
    maxSteps: number;
    fallbackNodeId?: string | null;
  };
}

export const DEFAULT_GRAPH: AgentGraphDefinitionModel = {
  entryNodeId: 'router',
  settings: { maxSteps: 20, fallbackNodeId: 'respond' },
  nodes: [
    {
      id: 'router',
      type: 'LlmRouter',
      config: { description: 'Decide entre usar uma tool ou responder ao usuário' },
    },
    { id: 'respond', type: 'Respond', config: {} },
  ],
  edges: [{ from: 'router', to: 'respond', condition: { action: 'respond' } }],
};

export function parseGraphDefinition(json: string): AgentGraphDefinitionModel {
  try {
    const raw = JSON.parse(json) as Partial<AgentGraphDefinitionModel>;
    return {
      entryNodeId: raw.entryNodeId ?? DEFAULT_GRAPH.entryNodeId,
      nodes: Array.isArray(raw.nodes) ? raw.nodes : DEFAULT_GRAPH.nodes,
      edges: Array.isArray(raw.edges) ? raw.edges : DEFAULT_GRAPH.edges,
      settings: {
        maxSteps: raw.settings?.maxSteps ?? 20,
        fallbackNodeId: raw.settings?.fallbackNodeId ?? null,
      },
    };
  } catch {
    return { ...DEFAULT_GRAPH, nodes: [...DEFAULT_GRAPH.nodes], edges: [...DEFAULT_GRAPH.edges] };
  }
}

export function serializeGraphDefinition(model: AgentGraphDefinitionModel): string {
  return JSON.stringify(model, null, 2);
}

export function graphNodeTypeLabel(type: AgentGraphNodeType): string {
  switch (type) {
    case 'LlmRouter':
      return 'Roteador LLM';
    case 'Tool':
      return 'Ferramenta';
    case 'Condition':
      return 'Condição';
    case 'Respond':
      return 'Resposta';
    default:
      return type;
  }
}

export function graphNodeTypeColor(type: AgentGraphNodeType): string {
  switch (type) {
    case 'LlmRouter':
      return 'border-violet-400 bg-violet-50';
    case 'Tool':
      return 'border-amber-400 bg-amber-50';
    case 'Condition':
      return 'border-cyan-400 bg-cyan-50';
    case 'Respond':
      return 'border-emerald-400 bg-emerald-50';
    default:
      return 'border-gray-300 bg-gray-50';
  }
}
